import React from 'react';
import {connect} from 'react-redux';
import {setSelectedPricePlan} from '../../TransferOrganizationAccountSlice';
import {SelectedPackageType} from '../../Constant/Constant';
import SalePackages from '../../../SalePackagesBlock/SalePackages';
import {isMobile} from 'react-device-detect';

const EpiPricePlan = (props) => {
  const selectedBanSegment = props.data.banListForSelect.find((ban) => ban.banNumber == props.data.selectedBanNumber)?.segment;

  return (
    <>
      {selectedBanSegment === 'M' && props.data.epiData.packagesList.expandedValue.length > 0 ? (
        <div>
          <div className='L_Title'>חבילות הסלולר המובילות לעסקים</div>
          <div className={`generic_packages_epi ${props.data.selectedPricePlanType == SelectedPackageType.epi ? 'selected' : ''}`}>
            <SalePackages
              packages={props.data.epiData.packagesList}
              onSelectedPackages={(newPackage) => props.setSelectedPricePlan({plan: newPackage, type: SelectedPackageType.epi})}
              oneTimeFee={false}
              isChangePricePlan={false}
              setBorder={true}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
});

const mapDispatchToProps = {
  setSelectedPricePlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(EpiPricePlan);
